import { Box, Text } from '@chakra-ui/react'

const ErrorFallback = ({ error }: { error: Error }) => {
  return (
    <Box
      role="alert"
      p={4}
      bg="red.600"
      color="white"
      borderRadius="md"
      m={4}
    >
      <Text fontWeight="bold">Something went wrong:</Text>
      <Text mt={2}>{error.message}</Text>
    </Box>
  )
}

export default ErrorFallback